function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React, {useMemo} from "react";
import {cmpClassName} from "../../../common/generic-react.functions.js";
import {LabelContainer, LabelRequiredContainer} from "./label.styles.js";
function MainLabel({
  children,
  tag = "label",
  bgColor = "transparent",
  color = "inherit",
  disabled,
  size = "base",
  bold = false,
  htmlFor,
  required,
  onClick,
  ...otherProps
}) {
  const requiredSpan = useMemo(() => /* @__PURE__ */ React.createElement(LabelRequiredContainer, {
    required
  }, "*"), [required]);
  return /* @__PURE__ */ React.createElement(LabelContainer, _extends({
    className: cmpClassName("label")
  }, otherProps, {
    as: tag,
    bold,
    color,
    bgColor,
    disabled,
    size,
    htmlFor,
    "aria-required": !!required,
    clickable: !!onClick,
    onClick
  }), required && typeof required === "string" && required === "right" && requiredSpan, children, required && [true, "left"].includes(required) && requiredSpan);
}
MainLabel.displayName = "Label";
const Label = /* @__PURE__ */ React.memo(MainLabel);
Label.displayName = "Label";
export default Label;
